import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import InlineHelpText from '../../shared/InlineHelpText';
import InlineWarningText from '../../shared/InlineWarningText';
import SvgOpenExternal from '../../svg/OpenExternal';
import {
  descriptionText,
  batteryHelpText,
  batteryLowHelpText,
  quickEditAlarmDevicesText,
  quickEditAlertDevicesText,
  typeText,
} from '../../shared/SharedInternationalizations';
import HelpIcon from '../../shared/HelpIcon';
import Table from '../../shared/table/Table';
import { FormattedMessage } from 'react-intl';
import SvgBatteryOk from '../../svg/BatteryOk';
import SvgBatteryAlert from '../../svg/BatteryAlert';
import permissions from '../../../permissionsList';
import AccessControl from '../../../AccessControl';

export function UnconnectedUnitDevices(props) {
  const location = useLocation();
  const currentLocation = location.pathname + location.search;
  const {
    alertDeviceList,
    alarmDeviceList,
    alarmDeviceTypes,
    alertDeviceTypes,
    unit,
  } = props;
  const { id, is_active } = unit;
  const [
    showAssignedAlertDevicesHelpText,
    setShowAssignedAlertDevicesHelpText,
  ] = useState(false);
  const assignedAlertDevicesHelpTextRef = useRef();
  function toggleAssignedAlertDevicesHelpText(value) {
    setShowAssignedAlertDevicesHelpText(value);
  }

  const assignedAlertDevicesHelpText = (
    <FormattedMessage
      id="unitDisplay.assignedAlertDevicesHelpText"
      defaultMessage="These are alert devices that have been assigned to this unit."
      description="Help text explaining who the assigned users are"
    />
  );
  const [
    showAssignedAlarmDevicesHelpText,
    setShowAssignedAlarmDevicesHelpText,
  ] = useState(false);
  const assignedAlarmDevicesHelpTextRef = useRef();
  function toggleAssignedAlarmDevicesHelpText(value) {
    setShowAssignedAlarmDevicesHelpText(value);
  }

  const assignedAlarmDevicesHelpText = (
    <FormattedMessage
      id="unitDisplay.assignedAlarmDevicesHelpText"
      defaultMessage="These are monitored devices that have been assigned to this unit."
      description="Help text explaining who the assigned users are"
    />
  );

  const [
    showQuickEditAlertDevicesHelpText,
    setShowQuickEditAlertDevicesHelpText,
  ] = useState(false);
  const quickEditAlertDevicesHelpTextRef = useRef();
  function toggleQuickEditAlertDevicesHelpText(value) {
    setShowQuickEditAlertDevicesHelpText(value);
  }

  const quickEditAlertDevicesHelpText = (
    <FormattedMessage
      id="unitDisplay.quickEditAlertDevicesHelpText"
      defaultMessage="Clicking this button will take you to the interface where you can add or remove alert devices assigned to this unit."
      description="Help text for understanding what the quick edit devices interface is"
    />
  );
  const [
    showQuickEditAlarmDevicesHelpText,
    setShowQuickEditAlarmDevicesHelpText,
  ] = useState(false);

  const quickEditAlarmDevicesHelpTextRef = useRef();
  function toggleQuickEditAlarmDevicesHelpText(value) {
    setShowQuickEditAlarmDevicesHelpText(value);
  }

  const quickEditAlarmDevicesHelpText = (
    <FormattedMessage
      id="unitDisplay.quickEditAlarmDevicesHelpText"
      defaultMessage="Clicking this button will take you to the interface where you can add or remove monitored devices assigned to this unit."
      description="Help text for understanding what the quick edit devices interface is"
    />
  );

  const [showAssignedPOIsHelpText, setShowAssignedPOIsHelpText] = useState(
    false
  );

  const assignedPOIsHelpTextRef = useRef();
  function toggleAssignedPOIsHelpText(value) {
    setShowAssignedPOIsHelpText(value);
  }
  const assignedPOIsHelpText = (
    <FormattedMessage
      id="unitDisplay.assignedPOIsHelpText"
      defaultMessage="These are points of interest have been assigned to this unit."
      description="Help text explaining who the assigned users are"
    />
  );
  const [showQuickEditPOIsHelpText, setShowQuickEditPOIsHelpText] = useState(
    false
  );
  const quickEditPOIsHelpTextRef = useRef();
  function toggleQuickEditPOIsHelpText(value) {
    setShowQuickEditPOIsHelpText(value);
  }
  const quickEditPOIsHelpText = (
    <FormattedMessage
      id="unitDisplay.quickEditPOIsHelpText"
      defaultMessage="Clicking this button will take you to the interface where you can add or remove the points of interest assigned to this unit."
      description="Help text for understanding what the quick edit POIs interface is"
    />
  );
  const quickEditPOIsText = (
    <FormattedMessage
      id="unitDisplay.quickEditPOIsText"
      defaultMessage="Quick Edit POIs"
      description="A link to open the interface to edit the devices assigned to this unit"
    />
  );

  const alertBatteryLowRef = useRef();
  const alarmBatteryLowRef = useRef();
  const alertBatteryRef = useRef();
  const alarmBatteryRef = useRef();

  /**
   * Function to generate the units table
   * @returns {object} - The table of units
   */
  const alertDevicesTable = () => {
    const alertDeviceDetailsList = [];
    alertDeviceList.map((details) => {
      let batteryIcon = (
        <div className="align-center height-100 flex-end text-success text-extra-large">
          <SvgBatteryOk
            className="cursor-pointer margin-right-10"
            onClick={() => alertBatteryRef.current.toggleHelpText()}
          />
        </div>
      );
      if (details.battery_low) {
        batteryIcon = (
          <div className="align-center height-100 flex-end text-alert text-extra-large">
            <SvgBatteryAlert
              className="cursor-pointer margin-right-10"
              onClick={() => alertBatteryLowRef.current.toggleHelpText()}
            />
          </div>
        );
      }

      let deviceLink = (
        <AccessControl
          data-test="access-control"
          feature={permissions.static.devices.alert.editAlertDevice}>
          <FormattedMessage
            id="unitDevices.viewAlertDeviceText"
            defaultMessage="View Device"
            description="Button to view full unit info">
            {(txt) => (
              <div className="width-100 flex-end height-100 align-center">
                <a
                  data-test="view-alert-device-link"
                  className="text-small margin-right-10 link-text align-center"
                  href={`/admin/alert_dev_edit.php?&alert_device_options=&mode=edit&edit_row[alert_device_id]=${details.alert_device_id}&edit_row[alert_device_type]=${details.alert_device_type}`}>
                  {txt} <SvgOpenExternal className="margin-left-5" />
                </a>
              </div>
            )}
          </FormattedMessage>
        </AccessControl>
      );
      if (
        details.alert_device_type === 3 ||
        details.alert_device_type === 4 ||
        details.alert_device_type === 24 ||
        details.alert_device_type === 25
      ) {
        deviceLink = (
          <AccessControl
            data-test="access-control"
            feature={permissions.static.devices.alert.editAlertDevice}>
            <FormattedMessage
              id="unitDevices.viewAlertDeviceText"
              defaultMessage="View Device"
              description="Button to view full unit info">
              {(txt) => (
                <div className="width-100 flex-end height-100 align-center">
                  <Link
                    data-test="view-alert-device-link-typed"
                    to={`/devices/alert/${details.alert_device_id}/view/`}
                    state={{
                      previous: currentLocation,
                    }}
                    className="text-small margin-right-10 link-text align-center">
                    {txt} <SvgOpenExternal className="margin-left-5" />
                  </Link>
                </div>
              )}
            </FormattedMessage>
          </AccessControl>
        );
      }

      alertDeviceDetailsList.push({
        id: details.alert_device_id,
        description: details.alert_description,
        battery: batteryIcon,
        type: details.alert_device_type,
        view: deviceLink,
      });

      return '';
    });

    // map over the units and put into the format that is required for the table component
    if (alertDeviceDetailsList.length > 0) {
      const devicesArray = alertDeviceDetailsList.map((d) => {
        let deviceType = '';
        if (alertDeviceTypes[d.type]) {
          deviceType = alertDeviceTypes[d.type].description;
        }
        return {
          description: {
            sortBy: d.description.toUpperCase(),
            display: d.description,
          },
          type: {
            sortBy: deviceType.toUpperCase(),
            display: deviceType,
          },
          // battery: {
          //   sortBy: '',
          //   display: d.battery,
          // },
          view: {
            sortBy: '',
            display: d.view,
          },
        };
      });
      // Take the array and filter based on the text entered in the search bar.

      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: true,
          sortBy: 'type',
          display: typeText,
        },
        // {
        //   isSortable: false,
        //   sortBy: 'battery',
        //   display: batteryStatusText,
        // },
        {
          isSortable: false,
          sortBy: 'view',
          display: '',
        },
      ];

      // generates the actual table
      const table = (
        <Table
          hasTableHead={false}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="description"
          tableData={devicesArray}
          tableStyles="table-layout__3-column"
          data-test="associated-alert-devices-table"
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10">
          <FormattedMessage
            data-test="no-associated-alert-devices"
            id="unitDevices.noAlertDevicesText"
            defaultMessage="No Alert Devices Assigned"
            description="The user's contact phone number"
          />
        </span>
      );
    }
  };

  /**
   * Function to generate the units table
   * @returns {object} - The table of units
   */
  const alarmDevicesTable = () => {
    const devicesArr = alarmDeviceList.filter((d) => {
      if (d.hardware_type !== 12) {
        return true;
      } else {
        return false;
      }
    });

    const alarmDeviceDetailsList = [];
    devicesArr.map((device) => {
      let batteryIcon = (
        <div className="align-center height-100 flex-end text-success text-extra-large">
          <SvgBatteryOk
            className="cursor-pointer margin-right-10"
            onClick={() => alarmBatteryRef.current.toggleHelpText()}
          />
        </div>
      );
      if (device.battery_low) {
        batteryIcon = (
          <div className="align-center height-100 flex-end text-alert text-extra-large">
            <SvgBatteryAlert
              className="cursor-pointer margin-right-10"
              onClick={() => alarmBatteryLowRef.current.toggleHelpText()}
            />
          </div>
        );
      }

      const deviceLink = (
        <AccessControl
          data-test="access-control"
          feature={permissions.static.devices.alarm.editAlarmDevice}>
          <FormattedMessage
            id="unitDevices.viewDeviceText"
            defaultMessage="View Device"
            description="Button to view full unit info">
            {(txt) => (
              <div className="width-100 flex-end height-100 align-center">
                <a
                  data-test="view-alarm-device-link"
                  className="text-small margin-right-10 link-text align-center"
                  href={`/admin/alarm_dev_edit_new.php?edit_row[alarm_device_id]=${device.alarm_device_id}&edit_row[alarm_device_type]=${device.alarm_device_type}&orig_type= 1`}>
                  {txt} <SvgOpenExternal className="margin-left-5" />
                </a>
              </div>
            )}
          </FormattedMessage>
        </AccessControl>
      );

      alarmDeviceDetailsList.push({
        id: device.alarm_device_id,
        description: device.alarm_description,
        battery: batteryIcon,
        type: device.alarm_device_type,
        view: deviceLink,
      });

      return '';
    });

    // map over the units and put into the format that is required for the table component
    if (alarmDeviceDetailsList.length > 0) {
      const devicesArray = alarmDeviceDetailsList.map((d) => {
        let deviceType = '';
        if (alarmDeviceTypes[d.type]) {
          deviceType = alarmDeviceTypes[d.type].description;
        }
        return {
          description: {
            sortBy: d.description.toUpperCase(),
            display: d.description,
          },
          type: {
            sortBy: deviceType.toUpperCase(),
            display: deviceType,
          },
          // battery: {
          //   sortBy: '',
          //   display: d.battery,
          // },
          view: {
            sortBy: '',
            display: d.view,
          },
        };
      });
      // Take the array and filter based on the text entered in the search bar.

      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: true,
          sortBy: 'type',
          display: typeText,
        },
        // {
        //   isSortable: false,
        //   sortBy: 'battery',
        //   display: batteryStatusText,
        // },
        {
          isSortable: false,
          sortBy: 'view',
          display: '',
        },
      ];

      // generates the actual table
      const table = (
        <Table
          hasTableHead={false}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="description"
          tableData={devicesArray}
          tableStyles="table-layout__3-column"
          data-test="associated-alarm-devices-table"
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10">
          <FormattedMessage
            data-test="no-associated-alarm-devices"
            id="unitDevices.noAlarmDevicesText"
            defaultMessage="No Monitored Devices Assigned"
            description="The user's contact phone number"
          />
        </span>
      );
    }
  };

  /**
   * Function to generate the units table
   * @returns {object} - The table of units
   */
  const poisTable = () => {
    const poiArr = alarmDeviceList.filter((d) => {
      if (d.hardware_type === 12) {
        return true;
      } else {
        return false;
      }
    });

    const alarmDeviceDetailsList = [];
    poiArr.map((device) => {
      const deviceLink = (
        <AccessControl
          data-test="access-control"
          feature={permissions.static.devices.alarm.editAlarmDevice}>
          <FormattedMessage
            id="unitDevices.viewDeviceText"
            defaultMessage="View Device"
            description="Button to view full unit info">
            {(txt) => (
              <div className="width-100 flex-end height-100 align-center">
                <a
                  data-test="view-alarm-device-link"
                  className="text-small margin-right-10 link-text align-center"
                  href={`/admin/alarm_dev_edit_new.php?edit_row[alarm_device_id]=${device.alarm_device_id}&edit_row[alarm_device_type]=${device.alarm_device_type}&orig_type= 1`}>
                  {txt} <SvgOpenExternal className="margin-left-5" />
                </a>
              </div>
            )}
          </FormattedMessage>
        </AccessControl>
      );

      alarmDeviceDetailsList.push({
        id: device.alarm_device_id,
        description: device.alarm_description,
        type: device.alarm_device_type,
        view: deviceLink,
      });
      return '';
    });

    // map over the units and put into the format that is required for the table component
    if (alarmDeviceDetailsList.length > 0) {
      const devicesArray = alarmDeviceDetailsList.map((d) => {
        let deviceType = '';
        if (alarmDeviceTypes[d.type]) {
          deviceType = alarmDeviceTypes[d.type].description;
        }
        return {
          description: {
            sortBy: d.description.toUpperCase(),
            display: d.description,
          },
          type: {
            sortBy: deviceType.toUpperCase(),
            display: deviceType,
          },

          view: {
            sortBy: '',
            display: d.view,
          },
        };
      });
      // Take the array and filter based on the text entered in the search bar.

      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: true,
          sortBy: 'type',
          display: typeText,
        },

        {
          isSortable: false,
          sortBy: 'view',
          display: '',
        },
      ];

      // generates the actual table
      const table = (
        <Table
          hasTableHead={false}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="description"
          tableData={devicesArray}
          tableStyles="table-layout__3-column"
          data-test="associated-pois-table"
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10">
          <FormattedMessage
            data-test="no-associated-poi-devices"
            id="unitDevices.noPoisText"
            defaultMessage="No POIs Assigned"
            description="The user's contact phone number"
          />
        </span>
      );
    }
  };

  return (
    <div className="content-display__container" data-test="content-container">
      <div
        className="content-display__column"
        data-test="active-unit-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            <div className="item-container__main-text text-large text-light flex-spread margin-bottom-10">
              <div className="align-center">
                <FormattedMessage
                  id="unitDisplay.assignedAlertDevicesText"
                  defaultMessage="Assigned Alert Devices:"
                  description="The assigned alert devices for this unit"
                />
                <HelpIcon
                  onClick={() =>
                    assignedAlertDevicesHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showAssignedAlertDevicesHelpText}
                  styles="margin-left-5"
                />
              </div>
              <div className="align-center">
                <AccessControl
                  data-test="access-control"
                  feature={permissions.static.devices.addDeviceAssociation}>
                  {is_active ? (
                    <Link
                      data-test="associate-alert-device"
                      className="link-button button-secondary button-xsm text-small link-secondary"
                      to={`/units/${id}/edit/?mode=associateAlertDevice`}
                      state={{
                        modal: true,
                        previous: currentLocation,
                      }}>
                      {quickEditAlertDevicesText}
                    </Link>
                  ) : (
                    ''
                  )}
                </AccessControl>

                <HelpIcon
                  onClick={() =>
                    quickEditAlertDevicesHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showQuickEditAlertDevicesHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>
            <div
              className="item-container__secondary-text text-medium text-bold"
              data-test="user-active-unit-link">
              {alertDevicesTable()}
            </div>
          </div>
          <div className="item-container__info-container"></div>
        </div>
        <InlineHelpText
          ref={assignedAlertDevicesHelpTextRef}
          toggleFunction={toggleAssignedAlertDevicesHelpText}
          message={assignedAlertDevicesHelpText}
        />
        <InlineHelpText
          ref={quickEditAlertDevicesHelpTextRef}
          toggleFunction={toggleQuickEditAlertDevicesHelpText}
          message={quickEditAlertDevicesHelpText}
        />
      </div>
      <div
        className="content-display__column"
        data-test="active-unit-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            <div className="item-container__main-text text-large text-light flex-spread margin-bottom-10">
              <div className="align-center">
                <FormattedMessage
                  id="unitDisplay.assignedAlarmDevicesText"
                  defaultMessage="Assigned Monitored Devices:"
                  description="The assigned alarm devices for this unit"
                />
                <HelpIcon
                  onClick={() =>
                    assignedAlarmDevicesHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showAssignedAlarmDevicesHelpText}
                  styles="margin-left-5"
                />
              </div>
              <div className="align-center">
                <AccessControl
                  data-test="access-control"
                  feature={permissions.static.devices.addDeviceAssociation}>
                  {is_active ? (
                    <Link
                      data-test="associate-alarm-device"
                      className="link-button button-secondary button-xsm text-small link-secondary"
                      to={`/units/${id}/edit/?mode=associateAlarmDevice`}
                      state={{
                        modal: true,
                        previous: currentLocation,
                      }}>
                      {quickEditAlarmDevicesText}
                    </Link>
                  ) : (
                    ''
                  )}
                </AccessControl>

                <HelpIcon
                  onClick={() =>
                    quickEditAlarmDevicesHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showQuickEditAlarmDevicesHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>
            <div
              className="item-container__secondary-text text-medium text-bold"
              data-test="user-active-unit-link">
              {alarmDevicesTable()}
            </div>
          </div>
          <div className="item-container__info-container"></div>
        </div>
        <InlineHelpText
          ref={assignedAlarmDevicesHelpTextRef}
          toggleFunction={toggleAssignedAlarmDevicesHelpText}
          message={assignedAlarmDevicesHelpText}
        />
        <InlineHelpText
          ref={quickEditAlarmDevicesHelpTextRef}
          toggleFunction={toggleQuickEditAlarmDevicesHelpText}
          message={quickEditAlarmDevicesHelpText}
        />
        <InlineWarningText
          ref={alarmBatteryLowRef}
          message={batteryLowHelpText}
        />
        <InlineHelpText ref={alarmBatteryRef} message={batteryHelpText} />
      </div>
      <div className="content-display__column" data-test="poi-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            <div className="item-container__main-text text-large text-light">
              <FormattedMessage
                id="unitDisplay.assignedPOIsText"
                defaultMessage="Assigned Points of Interest:"
                description="The assigned points of interest for this unit"
              />
              <HelpIcon
                onClick={() => assignedPOIsHelpTextRef.current.toggleHelpText()}
                toggled={showAssignedPOIsHelpText}
                styles="margin-left-5"
              />
            </div>
            <div
              className="item-container__secondary-text text-medium text-bold"
              data-test="unit-poi-link">
              {poisTable()}
            </div>
          </div>
          <div className="item-container__info-container">
            <AccessControl
              data-test="access-control"
              feature={permissions.static.devices.addDeviceAssociation}>
              {is_active ? (
                <Link
                  className="link-button button-secondary button-xsm text-small"
                  to={`/units/${id}/edit/?mode=editPois`}
                  state={{
                    modal: true,
                    unit: id,
                    previous: currentLocation,
                  }}>
                  {quickEditPOIsText}
                </Link>
              ) : (
                ''
              )}
            </AccessControl>

            <HelpIcon
              onClick={() => quickEditPOIsHelpTextRef.current.toggleHelpText()}
              toggled={showQuickEditPOIsHelpText}
              styles="margin-left-5"
            />
          </div>
        </div>
        <InlineHelpText
          ref={assignedPOIsHelpTextRef}
          toggleFunction={toggleAssignedPOIsHelpText}
          message={assignedPOIsHelpText}
        />
        <InlineHelpText
          ref={quickEditPOIsHelpTextRef}
          toggleFunction={toggleQuickEditPOIsHelpText}
          message={quickEditPOIsHelpText}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    alarmDeviceTypes: state.devices.alarmDeviceTypes,
    alertDeviceTypes: state.devices.alertDeviceTypes,
  };
};

export default connect(mapStateToProps)(UnconnectedUnitDevices);
